import classes from './TeamStat.module.css'
import { Typography } from '../../common/typography'

export default function TeamStat({
  title,
  value,
  decimals,
}: {
  title: string
  value: number
  decimals?: number
}) {
  const displayValue = decimals !== undefined ? value.toFixed(decimals) : value

  return (
    <div className={classes.container}>
      <Typography fw={500} lh="130" ta="center">
        {title}
      </Typography>
      <Typography fw={500} lh="130" ff="JetBrains Mono">
        {displayValue}
      </Typography>
    </div>
  )
}
